<script setup>
    defineProps({
        type: {
            type: String,
            default: "submit",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    });
</script>

<template>
    <button
        :disabled="disabled"
        :type="type"
        class="inline-flex items-center px-4 py-2 bg-primary border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-tertiary hover:text-black disabled:bg-secondary disabled:cursor-not-allowed focus:bg-tertiary active:bg-tertiary focus:outline-hidden focus:ring-2 focus:ring-secondary focus:ring-offset-2 transition ease-in-out duration-150"
    >
        <slot />
    </button>
</template>
